const convertSlugToUrl = (slug) => {
  return `${process.env.REACT_APP_BAZAARGHAR_URL}/video/${slug}`;
};
export default convertSlugToUrl;
